import { render } from "./Convaincus.vue?vue&type=template&id=88fd3b6e&scoped=true"
import script from "./Convaincus.vue?vue&type=script&lang=js"
export * from "./Convaincus.vue?vue&type=script&lang=js"

import "./Convaincus.vue?vue&type=style&index=0&id=88fd3b6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88fd3b6e"]])

export default __exports__